import axios from 'axios';
import config from '../config';
import store from '../../store/index';

/**
 * Create a new user.
 *
 * @param {string} email - user's email
 * @param {string} pass - user's password
 * @param {string} passphrase - BIP39 mnemonic passphrase https://github.com/bitpay/bitcore-mnemonic
 *
 * @return {object} - A success response object https://api.luxtag.io:8443/apidoc/#api-User-CreateUser
 */

function create(email, pass, passphrase, pp, address) {
  if (arguments.length < 3 || email === '' || pass === '' || passphrase === '') {
    throw new Error('Missing argument in create user request!');
  } else {
    return axios({
      method: 'post',
      baseURL: config.host,
      url: '/auth/local/register',
      timeout: config.timeout,
      data: {
        username: email,
        email: email,
        password: pass,
        passphrase: passphrase,
        public_key: pp,
        picture: `https://api.adorable.io/avatars/285/${email}.png`,
        address: address,
        active: true,
      },
    });
  }
}

function claimAsset(assetAddress) {
  const token = store.getters.getAuth.token;
  return axios({
    method: 'post',
    baseURL: config.host,
    url: `/assets/claim/${assetAddress}`,
    timeout: config.timeout,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

/**
 * User request of forgot password.
 *
 * @param {string} email - user's email
 *
 * @return {object} - A success response object https://api.luxtag.io:8443/apidoc/#api-User-forgotPassword
 */

function forgotPw(email) {
  if (arguments.length < 1 || email === '') {
    throw new Error('Missing email in forgot password request!');
  } else {
    return axios({
      method: 'post',
      baseURL: config.host,
      url: '/auth/forgot-password',
      timeout: config.timeout,
      data: {
        email: email,
        url: `${config.siteurl}/#/reset/`,
      },
    });
  }
}

/**
 * User request to reset password.
 * @param {string} resetToken - resetToken fetched from url
 *
 * @param {string} pass - user's password
 *
 * @return {object} - A success response object https://api.luxtag.io:8443/apidoc/#api-User-resetPassword
 */

function resetPw(resetToken, pass) {
  if (arguments.length < 1 || pass === '') {
    throw new Error('Missing password in reset password request!');
  } else {
    return axios({
      method: 'post',
      baseURL: config.host,
      url: '/auth/reset-password',
      timeout: config.timeout,
      data: {
        code: resetToken,
        password: pass,
        passwordConfirmation: pass,
      },
    });
  }
}

/**
 * Request to get current user.
 *
 *
 * @return {object} - A user object https://api.luxtag.io:8443/apidoc/#api-User-RetrieveCurrentUser
 */

function me() {
  const token = store.getters.getAuth.token;
  return axios.get(`${config.host}/user/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

/**
 * Request update user's password.
 *
 * @param {string} email - user's email
 * @param {string} oldPw - user's current password
 * @param {string} newPw - users's new password
 *
 *
 * @return {object} - A user object https://api.luxtag.io:8443/apidoc/#api-User-UpdatePassword
 */

function updatePw(oldPw, newPw) {
  const token = store.getters.getAuth.token;

  if (arguments.length < 2 || oldPw === '' || newPw === '') {
    throw new Error('Missing argument is update password Request!');
  } else {
    return axios({
      method: 'post',
      url: '/auth/change-password',
      baseURL: config.host,
      timeout: config.timeout,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        oldPassword: oldPw,
        newPassword: newPw,
      },
    });
  }
}

/**
 * Request to get current user account activation status.
 *
 *
 * @return {object} - a promise object either a boolean or an error
 */
function isActive() {
  return new Promise((resolve, reject) => {
    me().then((response) => {
      resolve(response.data.active);
    }).catch((e) => {
      reject(e);
    });
  });
}

export default {
  create: create,
  forgotPw: forgotPw,
  resetPw: resetPw,
  me: me,
  updatePw: updatePw,
  isActive: isActive,
  claimAsset: claimAsset,
};



// WEBPACK FOOTER //
// ./src/API/User/user.js